import { useQuery } from "@tanstack/react-query";
import { Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { api } from "../../lib/api";
import { PageLoader } from "../ui";

export function MarketplaceListingImpressionTrendPopover({
  listingId,
  listingTitle,
}: {
  listingId: string;
  listingTitle: string;
}) {
  const trendQuery = useQuery({
    queryKey: ["marketplace-listing-impression-trend", listingId],
    queryFn: () =>
      api<{ points: { date: string; listing: number; detail: number; search: number }[] }>(
        `/marketplace/admin/listings/${listingId}/impression-trend?days=30`,
      ),
  });

  if (trendQuery.isLoading) return <PageLoader />;

  const points = trendQuery.data?.points ?? [];

  return (
    <div className="w-[min(22rem,calc(100vw-2rem))] space-y-2 p-1">
      <p className="text-xs font-semibold text-foreground">{listingTitle}</p>
      <p className="text-[10px] text-muted">30-day views · grid, detail, search</p>
      {points.length === 0 ? (
        <p className="py-6 text-center text-xs text-muted">No impression data yet.</p>
      ) : (
        <div className="h-44 w-full">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={points} margin={{ top: 4, right: 8, left: -20, bottom: 0 }}>
              <XAxis dataKey="date" tick={{ fontSize: 9 }} tickFormatter={(v) => String(v).slice(5)} />
              <YAxis tick={{ fontSize: 9 }} allowDecimals={false} width={28} />
              <Tooltip contentStyle={{ fontSize: 11, borderRadius: 8 }} labelFormatter={(label) => String(label)} />
              <Legend wrapperStyle={{ fontSize: 10 }} />
              <Line type="monotone" dataKey="listing" name="Grid" stroke="#ec4899" strokeWidth={2} dot={false} />
              <Line type="monotone" dataKey="detail" name="Detail" stroke="#60a5fa" strokeWidth={2} dot={false} />
              <Line type="monotone" dataKey="search" name="Search" stroke="#a78bfa" strokeWidth={2} dot={false} />
            </LineChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
}
